<div class="container">
  <section class="header">
    <div class="header">{{ header }}</div>
    <div class="subheader">{{ subheader }}</div>
  </section>
  <section class="controller">
    <div class="row no-gutters justify-content-between align-items-center">
      <div class="month-label">{{ month }}</div>
      <div class="btn-group">
        <button id="previous" (click)="previous()">
          <i class="fas fa-chevron-left grey-text"></i>
        </button>
        <button id="next" (click)="next()">
          <i class="fas fa-chevron-right grey-text"></i>
        </button>
      </div>
    </div>
  </section>
  <section class="body">
    <div class="weekday" *ngFor="let s of ['S', 'M', 'T', 'W', 'T', 'F', 'S']">
      {{ s }}
    </div>
    <div
      class="date"
      *ngFor="let date of dates"
      (click)="select(date)"
      [ngClass]="{
        selected: isSelected(date),
        range: isInRange(date),
        empty: !isSelected(date) && !isInRange(date),
        other: isThisMonth(date),
        today: isToday(date)
      }"
    >
      {{ date.getDate() }}
    </div>
  </section>
  <section class="footer">
    <div
      class="form-group row justify-content-between no-gutters align-items-center"
    >
      <button id="btn-cancel" (click)="modalRef.hide()" type="button" mdbBtn>
        Cancel
      </button>
      <button
        id="btn-save"
        (click)="submit()"
        type="button"
        mdbBtn
        [ngClass]="{ disabled: firstDate == null }"
      >
        Select
      </button>
    </div>
  </section>
</div>
